import { render, staticRenderFns } from "./unit-item.vue?vue&type=template&id=496fa53c&scoped=true"
import script from "./unit-item.vue?vue&type=script&lang=js"
export * from "./unit-item.vue?vue&type=script&lang=js"
import style0 from "./unit-item.vue?vue&type=style&index=0&id=496fa53c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496fa53c",
  null
  
)

export default component.exports